/**
 * Voice enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Voice call direction
export const voiceCallDirectionLabels = {
    inbound: 'Inbound',
    outbound: 'Outbound',
};
export const voiceCallDirectionValues = Object.keys(voiceCallDirectionLabels);
// How an inbound call found its clinic (shared-number routing, in order).
export const voiceCallRouteLabels = {
    dedicated: 'Dedicated number',
    forwarded_from: 'Forwarded clinic line',
    known_caller: 'Known caller',
    front_desk: 'Asked the caller',
    unrouted: 'Not routed',
};
export const voiceCallRouteValues = Object.keys(voiceCallRouteLabels);
// Voice receptionist call ledger status
export const voiceReceptionistCallStatusLabels = {
    in_progress: 'In progress',
    completed: 'Completed',
    failed: 'Failed',
};
export const voiceReceptionistCallStatusValues = Object.keys(voiceReceptionistCallStatusLabels);
//# sourceMappingURL=voice.js.map